var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v(" Edit Primary Contact Details "),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          class: _vm.$style.body,
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "div",
            { class: _vm.$style.group },
            [
              _c(
                "rb-input",
                {
                  attrs: {
                    "for-id": "firstName",
                    error: _vm.$showError("firstName"),
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("First Name*"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.firstName,
                        expression: "data.firstName",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    staticClass: "rbInput",
                    attrs: {
                      id: "firstName",
                      name: "firstName",
                      "data-vv-as": "First Name",
                      placeholder: "First Name",
                      autofocus: "",
                    },
                    domProps: { value: _vm.data.firstName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.data, "firstName", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
              _c(
                "rb-input",
                {
                  attrs: {
                    "for-id": "lastName",
                    error: _vm.$showError("lastName"),
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Last Name*"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.lastName,
                        expression: "data.lastName",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    staticClass: "rbInput",
                    attrs: {
                      id: "name",
                      name: "lastName",
                      "data-vv-as": "Last Name",
                      placeholder: "Last Name",
                    },
                    domProps: { value: _vm.data.lastName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.data, "lastName", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "rb-input",
            { attrs: { "for-id": "email", error: _vm.$showError("email") } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Email Address"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.emailAddress,
                    expression: "data.emailAddress",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'",
                  },
                ],
                staticClass: "rbInput",
                attrs: {
                  id: "email",
                  name: "email",
                  "data-vv-as": "Email Address",
                },
                domProps: { value: _vm.data.emailAddress },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data, "emailAddress", $event.target.value)
                  },
                },
              }),
            ]
          ),
          _c(
            "rb-input",
            { attrs: { "for-id": "phone", error: _vm.$showError("phone") } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Phone Number"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.phone,
                    expression: "data.phone",
                  },
                ],
                staticClass: "rbInput",
                attrs: { id: "phone", name: "phone" },
                domProps: { value: _vm.data.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data, "phone", $event.target.value)
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _c(
            "button",
            { staticClass: "rbButton mainButton" },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
              !_vm.user.id
                ? [_vm._v(" Create New User ")]
                : [_vm._v(" Save User ")],
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }